'use client';

import React from 'react';
import Grow from '@mui/material/Grow';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { AuthContext } from '@/context/create-context';
import { HOME_PAGE_ROUTER_PATH } from '@/constants/router-path';
import SvgUser from '../SvgUser';
import SvgUserHover from '../SvgUserHover';
import SvgLogout from '../SvgLogout';
import { trackClickEvent } from '@/utils/site-track';
const Logout = () => {
  const logoutRef = React.useRef<HTMLDivElement>(null);
  const { logout } = React.useContext(AuthContext);

  const [open, setOpen] = React.useState(false);
  const [isClick, setIsClick] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
    if (logoutRef.current) {
      logoutRef.current.style.display = 'block';
      logoutRef.current.style.position = 'absolute';
    }
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (logoutRef.current) {
        logoutRef.current.style.display = 'none';
      }
    }, 150);
  };

  const handleClick = () => {
    setIsClick(true);
    if (!open) {
      handleOpen();
    }
  };

  const handleMouseLeave = () => {
    if (!isClick) {
      handleClose();
    }
  };
  const handleClickAway = () => {
    setIsClick(false);
    handleClose();
  };

  const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackClickEvent(e, true);
    const isOk = await logout();
    if (isOk) {
      handleClose();
      window.location.href = HOME_PAGE_ROUTER_PATH;
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        className="cursor-pointer relative flex-col items-center text-sm text-center whitespace-nowrap group mt-auto hidden tablet:flex"
        onClick={handleClick}
        onMouseEnter={handleOpen}
        onMouseLeave={handleMouseLeave}
        data-selected={open}
      >
        <span className="mb-1">
          <SvgUser className="block group-data-[selected=true]:hidden group-hover:hidden" />
          <SvgUserHover className="hidden group-data-[selected=true]:block group-hover:block" />
        </span>
        <span className="text-web-grey-500 group-data-[selected=true]:text-web-black-100 group-hover:text-web-black-100">
          账户设置
        </span>
        <div
          ref={logoutRef}
          className="left-1/2 top-0 -translate-y-full"
          style={{ display: 'none' }}
        >
          <Grow
            onClick={handleLogout}
            in={open}
            timeout={150}
            style={{ transformOrigin: 'bottom left' }}
            className="flex px-4 py-2.5 text-base font-semibold whitespace-nowrap cursor-pointer text-center bg-white rounded-lg shadow-[0px_2px_20px_0px_#0000001A] text-web-black-100 hover:text-web-blue-600"
            data-ele-group="navigation"
            data-ele-id="btn_log_out"
          >
            <div>
              <SvgLogout />
              <span className="ml-2">退出登录</span>
            </div>
          </Grow>
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default Logout;
